export let labels = {};
export function setLabels(newLabels) {
    labels = newLabels;
}
export function getLabel(label, fallback) {
    return labels[label] || fallback || '';
}
